import React, { useEffect, useRef } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from "../ui/card";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Button } from "../ui/button";
import { Plus } from "lucide-react";
import { useDirtyState } from "../../hooks/useDirtyState";
import { DirtyStateDialog } from "../shared/DirtyStateDialog";

const CreatePredictor = ({ newPredictor, setNewPredictor, handleCreate }) => {
    const { markDirty, resetDirty, showDialog, confirmNavigation, cancelNavigation } = useDirtyState(newPredictor);
    const prevPredictorRef = useRef(newPredictor);

    useEffect(() => {
        if (prevPredictorRef.current !== newPredictor) {
            resetDirty(newPredictor);
            prevPredictorRef.current = newPredictor;
        }
    }, [newPredictor, resetDirty]);

    const handleInputChange = (field, value) => {
        setNewPredictor(prev => {
            const updated = { ...prev, [field]: value };
            markDirty(updated);
            return updated;
        });
    };

    return (
        <>
            <Card className="mb-6">
                <CardHeader>
                    <CardTitle>Ajouter un prédicteur</CardTitle>
                </CardHeader>
                <CardContent>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-end">
                        <div className="grid w-full gap-1.5">
                            <Label htmlFor="create-predictor-name">Nom du prédicteur *</Label>
                            <Input
                                id="create-predictor-name"
                                type="text"
                                placeholder="Nom du prédicteur"
                                value={newPredictor.predictorname}
                                onChange={(e) => handleInputChange('predictorname', e.target.value)}
                                required
                            />
                        </div>
                        <div className="grid w-full gap-1.5">
                            <Label htmlFor="create-predictor-score">Score de compétence *</Label>
                            <Input
                                id="create-predictor-score"
                                type="number"
                                placeholder="Score de compétence"
                                value={newPredictor.proficiency_score}
                                onChange={(e) => handleInputChange('proficiency_score', e.target.value)}
                                required
                            />
                        </div>
                        <div className="md:col-span-2 flex justify-end">
                            <Button type="button" onClick={handleCreate} size="sm">
                                <Plus className="h-4 w-4 mr-1" />
                                Ajouter le predicteur
                            </Button>
                        </div>
                    </div>
                </CardContent>
            </Card>
            <DirtyStateDialog open={showDialog} onConfirm={confirmNavigation} onCancel={cancelNavigation} />
        </>
    );
};

export default CreatePredictor;
